import TextField from '@mui/material/TextField';
import { styled } from '@mui/material/styles';
import type { Theme, SxProps } from '@mui/material/styles';

const sharedInputStyles = (theme: Theme) => ({
  '& .MuiOutlinedInput-root': {
    fontSize: theme.typography.body2.fontSize,
    padding: 0,
    '& textarea': {
      height: theme.spacing(5),
      padding: theme.spacing(1.5, 1),
      border: 'none',
      fontSize: theme.typography.body2.fontSize,
      marginBottom: 0,
      '&:focus': {
        outline: 'none',
      },
    },
  },
});

const LegacyCaptionField = styled(TextField)(({ theme }) => ({
  marginTop: theme.spacing(1),
  ...sharedInputStyles(theme),
}));

const CaptionField = styled(TextField)(({ theme }) => ({
  marginTop: theme.spacing(1),
  marginLeft: theme.spacing(9),
  width: `calc(100% - ${theme.spacing(9)} - ${theme.spacing(9)})`,
  '& .MuiInputLabel-root': {
    fontSize: theme.typography.body2.fontSize,
    left: 0,
    top: 0,
    '&.Mui-focused, &.MuiFormLabel-filled': {
      left: 'inherit',
      top: 'inherit',
    },
  },
  ...sharedInputStyles(theme),
}));

const readOnlyCaptionSx: SxProps<Theme> = {
  pt: 1,
  ml: 9,
  pl: 1.5,
  width: (theme) => `calc(100% - ${theme.spacing(9)} - ${theme.spacing(9)})`,
  whiteSpace: 'pre-wrap',
  color: 'text.secondary',
  fontSize: (theme) => theme.typography.body2.fontSize,
};

export { CaptionField, LegacyCaptionField, readOnlyCaptionSx };
